import React from "react";
import SEO from '../services/SEO';
import { useTranslation } from "react-i18next";
import { List, Alert, Flex, Collapse, Button, Menu, Layout, Result, FloatButton, ConfigProvider, Affix, Tabs, Space, Table, Tag, InputNumber, Input, ColorPicker, Tree, Col, Row, Slider, QRCode, Divider } from 'antd';

const Contato = () => {

	window.scrollTo(0, 0);
	const { t, i18n: { changeLanguage, language } } = useTranslation();

	return (
		<div>
			<SEO title="TLS Engenharia" description="Descubra soluções inovadoras em software e tecnologia que impulsionam negócios e simplificam processos. Acesse e explore as últimas tendências tecnológicas!" />
			<h2 className="title is-1">{t("contato")}</h2>
			<br />
			<hr />
			<br />
			{/* <YoutubeEmbed embedId="rokGy0huYEA"/>
			<YoutubeEmbed embedId="rokGy0huYEA"/> */}
			<p style={{ fontSize: 16, lineHeight: '1.5em', textAlign: "justify" }}>{t("contato_msg.contato_txt")}</p>
			<Flex wrap gap="small" justify="center">
				<img src="img/contact_us.jpg" alt="contato img" style={{ width: "100%", maxWidth: "400px" }} />
			</Flex>
			<Flex wrap gap="small" justify="center">
				<h3>{t("cadastro_msg.email")}:</h3>
				{/* <p>contato@tlsengenharia.com.br</p> */}
				<a href="mailto:contato@tlsengenharia.com.br">contato@tlsengenharia.com.br</a>
			</Flex>

		</div>
	);
}


export default Contato;